import { intersection } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { UseFormReturn } from "react-hook-form";
import { Subject } from "rxjs";
import { filter } from "rxjs/operators";
import { AllowedBlockchains } from "../../../../store/chain/models/internal";
import { keys } from "../../../../utils/utils";
import { FormType } from "./common";

export function useSelectedChains(innerForm: UseFormReturn<Partial<FormType>>) {
  const [selectedChains, setSelectedChains] = useState<
    Array<AllowedBlockchains>
  >(() => {
    const currentValues = innerForm.getValues();
    return currentValues ? keys(currentValues) : [];
  });

  // Var to store the form's selected chains
  const [chainsValue, setChainsValue] = useState<Array<keyof FormType>>(
    selectedChains
  );

  // Remove/add when user toggles selected chains
  const selectedChainsSubject = useMemo(
    () => new Subject<typeof selectedChains>(),
    []
  );

  useEffect(() => {
    const sub = innerForm.watch((data) => {
      setChainsValue(keys(data));
    });

    return () => sub.unsubscribe();
  }, [innerForm]);

  useEffect(() => {
    const sub = selectedChainsSubject
      .pipe(
        filter((c) => {
          return (
            c.length !== chainsValue.length ||
            intersection(c, chainsValue).length < c.length
          );
        })
      )
      .subscribe((newChains) => {
        newChains.forEach((s) => {
          if (!chainsValue.includes(s)) {
            innerForm.setValue(s, { pledgingInfo: [] });
          }
        });
        chainsValue.forEach((s) => {
          if (!newChains.includes(s)) {
            innerForm.setValue(s, undefined, { shouldTouch: true });
          }
        });
      });
    return () => sub.unsubscribe();
  }, [selectedChainsSubject, innerForm.setValue, chainsValue]);

  useEffect(() => {
    selectedChainsSubject.next(selectedChains);
  }, [selectedChains]);

  return [selectedChains, setSelectedChains] as const;
}
